import React from "react";
import { List } from "semantic-ui-react";
import { storeSearchHistory } from "../actions/searchActions";
// import ReactGA from 'react-ga';
import { gaProviderInfo } from "../actions/gaevents";

interface ServiceListItemProps {
  item: any;
  setSelectedItem: Function;
  highlightOnHover: Function;
}

export const ServiceListItem = ({
  item,
  setSelectedItem,
  highlightOnHover,
}: ServiceListItemProps) => {
  const { Address: address, OrgName: orgName, ShortDesc } = item;
  const isOnline = address === "Online";
  const isSponsor = ShortDesc?.toLowerCase().includes("sponsor");

  const sponsorTagStyle = {
    color: "#fdf6ff",
    fontWeight: 700,
    fontSize: "0.75em",
    marginTop: 4,
    marginLeft: 0,
  };

  const itemStyle = {
    backgroundColor: isSponsor ? "#b790de" : "transparent", // light purple for sponsor
    borderRadius: "6px",
    padding: "0.75em",
  };
  
   const orgNameStyle = {
    color: isSponsor ? "#2e2e2e" : "inherit", // charcoal grey if sponsor
    fontWeight: 600,
  };



  return (
    <List.Item
      onClick={() => {
        setSelectedItem(item);
        storeSearchHistory(item);
        gaProviderInfo(orgName);
      }}
      onMouseEnter={() => highlightOnHover(item)}
      onMouseLeave={() => highlightOnHover("")}
      className="location-list"
      style={itemStyle}
    >
      <List.Content>
        <List.Header className={!isOnline ? "location-header" : "online-header"}>
          <div
            style={{ display: "inline-flex", lineHeight: "initial" }}
            className={
              !isOnline
                ? "location-header-inner servulink-geo-result-icon"
                : "online-header-inner servulink-online-result-icon"
            }
          >
            <div style={orgNameStyle}>
              {orgName}
              {isSponsor && (
                <>
                  <br />
                  <span style={sponsorTagStyle}>Proud Sponsor of Servulink</span>
                </>
              )}
            </div>
          </div>
        </List.Header>
      </List.Content>
    </List.Item>
  );
};

